<template>
  <b-modal
    v-model="ShowModal"
    id="modal-center"
    class="home-modal"
    size="md"
    no-close-on-backdrop="true"
    no-close-on-esc="true"
    centered
    hide-footer
    @close="handleOk"
  >
    <template v-slot:default>
      <div class="container">
        <div class="web-application-modal-slider">
          <slick ref="p-slick" :options="afterLoginSlickOptions">
            <div  v-for="item in items" :key="item.Id">
              <div class="banner">
              <h4>{{item.Title}}</h4>
              <p>{{item.Description }}</p>
                 <img :src="'api/image/banner/' + item.Id" :alt="item.Title" :title="item.Title" class="center"/>   
              <br/>
              <br/>
              <br/>
              <p1>{{item.HyperlinkBody}}</p1>
              <br/>
              <div v-if="item.Hyperlink">
                <b-button class="hyperlink-button" variant="danger" :href="item.Hyperlink" target="_blank">Click Here</b-button>
              </div>
          </div>
        </div>
          </slick>
        </div>
      </div>
      <br />
      <!-- <div class="modal-button-wrapper">
        <b-button class="modal-ok-button" variant="danger" @click="handleOk">CLOSE</b-button>
      </div> -->
    </template>
  </b-modal>
</template>
<script>
import Slick from "vue-slick";
export default {
  name: "AfterLoginBanner",
  components: {
    Slick,
  },
  props: ["ShowModal", "items"],

  data() {
    return {
      afterLoginSlickOptions: {
        dots: true,
        infinite: true,
        mobileFirst: true,
        navigation: false,
        variableWidth: false,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: false,
        pauseOnFocus: false,
      },
    };
  },

  methods: {
    handleOk: function (evt) {
      this.ShowModal = false;
      this.$emit("okclicked", this.ShowModal);
      evt.preventDefault();
    },
  },
};
</script>
<style scoped>
.banner {
	text-align: center;
	overflow: hidden;
	overflow-wrap: anywhere;
	}
.banner h4,.banner p ,.banner p1{
text-shadow: 1px 0 #131111;
font-weight:bold;

}
.banner h4{
  color:red;
}

.banner img{
  max-height: 275px;
  display:block;
  width:99%; 
}
.center {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 50%;
}
.hyperlink-button{
	border-radius: 10px;
  font-size: 80%;
  font-weight: bold;
}
</style>

